import { EIGHTH, G, HALF, HALF_G, QUARTER } from '@/constants/menu/product-sizes'

const isValidPricePerUnit = ({ product, indication }) => {
	return Array.isArray(product.pricing[indication]) && indication
}

export const getButtonClasses = ({ index, orderingDisabled, selectedIndex }) => {
	if (orderingDisabled) { return '' }
	return selectedIndex == index ? 'price-button-green' : ''
}

export const getPrice = ({ product, indication }) => {
	return product.pricing[indication]
}

export const hasPricing = ({ product, indication }) => {
	return product.pricing[indication] !== undefined &&
    product.pricing[indication] !== '0'
}

export const getPriceButtonBorderClasses = ({
	orderingDisabled,
	pricingIsArray,
	pricePerUnit
}) => {
	if (orderingDisabled) {
		const classes = 'outline-none pointer-events-none dashed-border-right'

		return !pricingIsArray || pricePerUnit.length === 1
			? 'pointer-events-none'
			: classes
	}
	return 'border-dashed border-2 rounded'
}

export const varToString = varObj => Object.keys(varObj)[0].toLowerCase()

export const formatUnit = unit => {
	switch (unit) {
		case varToString({ G }):
			return G
		case varToString({ HALF_G }):
			return HALF_G
		case varToString({ EIGHTH }):
			return `${EIGHTH} oz`
		case varToString({ QUARTER }):
			return `${QUARTER} oz`
		case varToString({ HALF }):
			return `${HALF} oz`
		default:
			return unit
	}
}

export const pricingIsArray = pricing => {
	return pricing.multi
}

export const getPricePerUnit = ({ product, indication }) => {
	try {
		if (!isValidPricePerUnit({ product, indication })) {
			return {}
		}

		return product.pricing[indication]
			.map((priceAndUnit, index) => ({
				unit: priceAndUnit[0],
				price: priceAndUnit[1],
				index
			}))
			.filter(({ price }) => {
				return price !== 0 && price !== null && parseFloat(price) > 0.00
			})
	} catch (e) {
		// console.log(e)
	}
}
